import React from 'react';
import { AppBar, UserMenu, Logout } from 'react-admin';
import { Box, Typography } from '@mui/material';

const MyAppBar = (props) => (
    <AppBar
        {...props}
        sx={{
            backgroundColor: '#1976d2',
            '& .RaAppBar-title': {
                flex: 1,
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
            },
            '& .RaAppBar-menuButton': {
                display: 'none', // Hide the hamburger menu button
            }
        }}
        userMenu={
            <UserMenu>
                <Logout />
            </UserMenu>
        }
    >
        <Box sx={{ flex: 1, display: 'flex', alignItems: 'center' }}>
            <img
                src={process.env.PUBLIC_URL + '/assets/deepalert_logo.png'}
                alt="DeepAlert"
                style={{ height: '30px', marginRight: '10px' }}
            />
        </Box>
    </AppBar>
);

export default MyAppBar;
